import React from 'react';

import I18n from '../../../lib/i18n';
import ListImage from './ListImage';
import NewsText from './NewsText';

interface IProps {
  listImage: string;
  text: string;
  movie: number;
  isDiscovery?: boolean;
}

export default class Entrance extends React.PureComponent<IProps> {
  public entranceWithCaptionComponent() {
    const { listImage, text, movie, isDiscovery = false } = this.props;

    if(isDiscovery){
      return(
        <div className="entrance list-image-preview gradient">
          <div className="entrance-for-discovery">
            <p className="entrance-for-discovery-text">{I18n.t('messages.preview.entrance_for_discovery')}</p>
          </div>
        </div>
      );
    }
    return (
      <div className="entrance list-image-preview gradient">
        <ListImage listImage={listImage} movie={movie}/>
        <NewsText className={'entrance-text'} text={text}/>
      </div>
    );
  }

  public entranceWithoutCaptionComponent() {
    const { listImage, movie } = this.props;
    return (
      <div className="entrance list-image-preview">
        <ListImage listImage={listImage} movie={movie}/>
      </div>
    );
  }

  public render() {
    const { text } = this.props;

    const entranceComponent =
      text ?
      this.entranceWithCaptionComponent() :
      this.entranceWithoutCaptionComponent();

    return (
      <div>
        <h4>{I18n.t('messages.preview.entrance')}</h4>
        {entranceComponent}
      </div>
    );
  }
}
